import { CommonEnums } from '../../common.enums';
export class Hbase_Inst {
    hbase_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    src_ConnNm: string;
    tgt_ConnNm: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.hbase_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = CommonEnums.defaults.LONG_VAL
        this.retryWaitTime = CommonEnums.defaults.LONG_VAL
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
    }

    copy(): Hbase_Inst {
        let hbase_InstTmp: Hbase_Inst = new Hbase_Inst();

        hbase_InstTmp.hbase_Inst_Id = this.hbase_Inst_Id;
        hbase_InstTmp.nm = this.nm;
        hbase_InstTmp.description = this.description;
        hbase_InstTmp.ver = this.ver;
        hbase_InstTmp.valid_Cd = this.valid_Cd;
        hbase_InstTmp.dxFlow_Id = this.dxFlow_Id;
        hbase_InstTmp.updateBy = this.updateBy;
        hbase_InstTmp.lastUpdateBy = this.lastUpdateBy;
        hbase_InstTmp.updateDt = this.updateDt;
        hbase_InstTmp.retryEnabled = this.retryEnabled;
        hbase_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        hbase_InstTmp.retryWaitTime = this.retryWaitTime;
        hbase_InstTmp.src_ConnNm = this.src_ConnNm;
        hbase_InstTmp.tgt_ConnNm = this.tgt_ConnNm;
        hbase_InstTmp.disableFlg = this.disableFlg;
        return hbase_InstTmp;
    }

    copyFrom(hbase_InstTmp: Hbase_Inst): void {
        this.hbase_Inst_Id = hbase_InstTmp.hbase_Inst_Id;
        this.nm = hbase_InstTmp.nm;
        this.description = hbase_InstTmp.description;
        this.ver = hbase_InstTmp.ver
        this.valid_Cd = hbase_InstTmp.valid_Cd
        this.dxFlow_Id = hbase_InstTmp.dxFlow_Id
        this.updateBy = hbase_InstTmp.updateBy
        this.lastUpdateBy = hbase_InstTmp.lastUpdateBy;
        this.updateDt = hbase_InstTmp.updateDt
        this.src_ConnNm = hbase_InstTmp.src_ConnNm
        this.retryEnabled = hbase_InstTmp.retryEnabled;
        this.numOfRetryAttempts = hbase_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = hbase_InstTmp.retryWaitTime;
         this.tgt_ConnNm = hbase_InstTmp.tgt_ConnNm;
        this.disableFlg = hbase_InstTmp.disableFlg;
    }

    compare(hbase_InstTmp: Hbase_Inst): string {
        let hbase_InstString: string = this.toString(false);
        let hbase_InstTmpString: string = hbase_InstTmp.toString(false);

        if (hbase_InstString != hbase_InstTmpString) {
            return hbase_InstString + ', ' + hbase_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Hbase_Inst [hbase_Inst_Id=" + this.hbase_Inst_Id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", dxFlow_Id=" + this.dxFlow_Id +
            ", updateBy=" + this.updateBy +
              ", updateDt=" + this.updateDt +
            ",disableFlg="+ this.disableFlg +
            ", retryEnabled =" + this.retryEnabled +
            ", numOfRetryAttempts =" + this.numOfRetryAttempts +
            ", retryWaitTime =" + this.retryWaitTime; 
           
            

            if (isNotCompare) {
                str = ",lastUpdateBy=" + this.lastUpdateBy + 
                ",  src_ConnNm =" + this.src_ConnNm +
                ",    tgt_ConnNm =" + this.tgt_ConnNm ;

    
            }
    
            str += ']';
            return str;
        }
    }
    
